export default "__VITE_ASSET__Cjr7U3vA__"